import { Component, OnDestroy, OnInit } from '@angular/core'
import { Blog, blogsPath, ParkingType } from '@parkupp/core'
import { Router } from '@angular/router'
import { collection, collectionData, Firestore, limit, orderBy, query } from '@angular/fire/firestore'
import { AdminService } from '../../../services/admin.service'
import { LazyLoaderService } from '../../../services/lazy-loader.service'
import { getFunctions, httpsCallable } from 'firebase/functions'
import * as firestore from 'firebase/firestore'
import { environment } from '../../../../environments/environment'
import { connectFunctionsEmulator } from '@angular/fire/functions'
import { GlobalService } from '../../../services/global.service'

@Component({
    selector: 'app-index',
    templateUrl: './index-page.component.html',
    styleUrls: ['./index-page.component.scss'],
})
export class IndexPageComponent implements OnInit, OnDestroy {
    GlobalService = GlobalService
    parkingTypes = ParkingType
    logos: string[] = []
    testimonials: any[] = []
    blogs: Blog[]

    customerLogos = [
        { alt: 'Horizon Logo', src: 'assets/images/customer-logos/horizon.png' },
        { alt: 'Hyprop Logo', src: 'assets/images/customer-logos/hyprop.png' },
        { alt: 'Investec Logo', src: 'assets/images/customer-logos/investec.png' },
        { alt: 'Ithemba Logo', src: 'assets/images/customer-logos/ithemba.png' },
        { alt: 'Rebosis Logo', src: 'assets/images/customer-logos/rebosis.png' },
    ]

    constructor(private globalService: GlobalService, public router: Router, private adminService: AdminService, private lazyLoaderService: LazyLoaderService, public firestore: Firestore) {
        // Whitelabel
        if (globalService.whitelabeled) {
            this.router.navigate(['/showcase'])
        }

        // Blogs
        const ref = query(collection(this.adminService.firestore, blogsPath()), orderBy('createdAt', 'desc'))
        collectionData(ref, { idField: 'documentId' }).subscribe((documents: any[]) => {
            this.blogs = []
            let blogCount = 0
            documents.forEach((documentData) => {
                let blog = new Blog(documentData)
                blog.$key = documentData.documentId
                if (blog.title && blogCount < 3) {
                    blogCount += 1
                    this.blogs.push(blog)
                }
            })
        })

        // Logos
        this.logos.push(
            'https://firebasestorage.googleapis.com/v0/b/parkupp-test.appspot.com/o/public%2Fwebsite%2Flogos%2Fengineering-news-mx%201.png?alt=media&token=60557be8-2aab-4db3-a218-51e7393cc07f'
        )
        this.logos.push('https://firebasestorage.googleapis.com/v0/b/parkupp-test.appspot.com/o/public%2Fwebsite%2Flogos%2Fdownload%201.png?alt=media&token=3a93d47e-83bb-4513-88f5-fc1bc765005b')
        this.logos.push('https://firebasestorage.googleapis.com/v0/b/parkupp-test.appspot.com/o/public%2Fwebsite%2Flogos%2Fdownload%20(5)%201.png?alt=media&token=6eacdd27-0b89-4173-98a9-4438c4a3c0f7')
        this.logos.push('https://firebasestorage.googleapis.com/v0/b/parkupp-test.appspot.com/o/public%2Fwebsite%2Flogos%2Fdownload%20(4)%201.png?alt=media&token=44df3b89-7673-4f6d-92e4-89ed1ce66185')
        this.logos.push('https://firebasestorage.googleapis.com/v0/b/parkupp-test.appspot.com/o/public%2Fwebsite%2Flogos%2Fdownload%20(3)%201.png?alt=media&token=3d362b43-5822-4514-8268-08ef9d6b560c')
        this.logos.push('https://firebasestorage.googleapis.com/v0/b/parkupp-test.appspot.com/o/public%2Fwebsite%2Flogos%2Fdownload%20(2)%201.png?alt=media&token=887105d1-4d4c-47cd-a381-0aee618a22d1')
        this.logos.push('https://firebasestorage.googleapis.com/v0/b/parkupp-test.appspot.com/o/public%2Fwebsite%2Flogos%2Fdownload%20(1)%201.png?alt=media&token=636fafad-7cc2-415f-b2ad-909653af7f1e')
        this.logos.push('https://firebasestorage.googleapis.com/v0/b/parkupp-test.appspot.com/o/public%2Fwebsite%2Flogos%2Fasset%201.png?alt=media&token=de45e535-7a47-45f6-aa31-eff5c611286c')

        this.testimonials.push({
            text: `This is going to change our daily lives. This is a small app with a huge impact. Time, convenience and peace of mind all in one solution.`,
            name: `Thando Gumede`,
        })
        this.testimonials.push({
            text: `Awesome App great way to make an extra income and also save time when looking for parking.`,
            name: `Matt Chanlee`,
        })
        this.testimonials.push({
            text: `No one thinks of parking challenges, until one needs parking. Excited to see how ParkUpp solves for parking across the entire spectrum.`,
            name: `Kamo Kekana`,
        })
        this.testimonials.push({
            text: `Super cool service. I knew my car was safe everytime i went to work. Cape town has been waitng for this. i hope we get it in Jhb too.`,
            name: `S'miso Skosana`,
        })
        this.testimonials.push({
            text: `Very forward thinking team at the helm of an excellent idea. ParkUpp is going places!`,
            name: `Bobo Nhleko`,
        })
        this.testimonials.push({
            text: `This is a new perspective on parking. It's going to change the world.`,
            name: `Jordan Minkowski`,
        })
    }

    ngOnInit(): void {
        // this.lazyLoaderService.loadElfsightJsScript()
    }

    ngOnDestroy(): void {
        window.location.href = this.router.url
    }

    selectParkingType(type: ParkingType) {
        this.router.navigate(['/map-search'], { queryParams: { parkingType: type } })
    }

    goToBlogPage(blog: Blog) {
        if (blog.link) {
            document.location.href = blog.link
            // window.open(blog.link, '_blank')
        } else {
            this.router.navigate([`blog/${blog.$key}`])
        }
    }
}
